import { Button } from '@mui/material';
import { IOrderStatus, IPreorderStatus } from 'my-poppies-b2b-types';

import { Container } from '@/components/Container';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';
import { IOrderEditOrigin } from '@/types/IOrderEditOrigin';
import { cleanLocalStorageKey } from '@/utils/cleanLocalStorageKey';

interface IOrderEditButtonProps {
  orderId: string;
  status: IOrderStatus | IPreorderStatus;
}

export const OrderEditButton = ({ orderId, status }: IOrderEditButtonProps) => {
  const t = useTranslation();
  const { push } = useAppPush();
  const orderEditOrigin: IOrderEditOrigin = status ?? 'root';

  return (
    <Container
      debugColor={'red'}
      sx={{ display: 'flex', alignItems: 'flex-start', flexGrow: 0, width: 'unset', margin: 'unset' }}
    >
      <Button
        onClick={() => {
          if (status !== 'INTERNAL_ORDER_COMPLETED') {
            cleanLocalStorageKey('ORDER_FORM');
            push(`/orders/edit?orderEditOrigin=${orderEditOrigin}&orderId=${orderId}`);
          } else {
            cleanLocalStorageKey('INTERNAL_ORDER_FORM');
            push(`/orders/edit-internal?orderEditOrigin=${orderEditOrigin}&orderId=${orderId}`);
          }
        }}
        sx={{
          fontSize: 'min(12px, 3dvw)',
        }}
      >
        {t('general.edit')}
      </Button>
    </Container>
  );
};
